<template>
  <div class="page_background">
    <div class="title_line">
      <el-page-header @back="goBack" content="会员详情"></el-page-header>
    </div>
    <div class="new_vip" v-loading="pageLoading">
      <!-- 基本信息 按钮 -->
      <div class="head_msg part_box">
        <div class="head_img">
          <el-avatar :size="80" :src="squareUrl"></el-avatar>
        </div>
        <div class="user_msg">
          <div class="user_msg_line">
            <div class="user_msg_item">
              会员姓名：{{ userDetail.user_info.real_name }}
              <template>
                <el-popover
                  placement="top"
                  width="160"
                  trigger="manual"
                  v-model="visible"
                >
                  <el-input
                    size="mini"
                    style="margin-bottom: 10px;"
                    v-model="username"
                    placeholder="请输入内容"
                  ></el-input>
                  <div style="text-align: right; margin: 0;">
                    <el-button size="mini" type="text" @click="visible = false">
                      取消
                    </el-button>
                    <el-button
                      type="primary"
                      size="mini"
                      @click="editCredit(userDetail.uid, 0)"
                    >
                      确定
                    </el-button>
                  </div>
                  <el-button
                    slot="reference"
                    style="margin-left: 5px;"
                    class="edit"
                    size="mini"
                    circle
                    icon="el-icon-edit"
                    @click="editCredit_hym"
                  ></el-button>
                </el-popover>
              </template>
            </div>
            <div class="user_msg_item">
              手机号：{{ userDetail.user_info.mobile }}
              <template>
                <el-popover
                  placement="top"
                  width="300"
                  trigger="manual"
                  v-model="visible_mobile"
                >
                  <el-input
                    placeholder="请输入新手机号"
                    v-model="icForm.mobile"
                    style="margin-bottom: 10px;"
                  ></el-input>
                  <br />
                  <el-form>
                    <verificationCodeVue :form="{
                    mobile:icForm.mobile
                  }" :typeCode="1"  v-model="verification_code" ></verificationCodeVue>
                  </el-form>
                  
                  <!-- <el-input
                    placeholder="请输入验证码"
                    v-model="verification_code"
                    style="margin-bottom: 10px;"
                  >
                    <el-button slot="append" @click="getCode(2)">
                      {{ code_text }}
                    </el-button>
                  </el-input> -->

                  <div style="text-align: right; margin: 0;">
                    <el-button
                      size="mini"
                      type="text"
                      @click="visible_mobile = false"
                    >
                      取消
                    </el-button>
                    <el-button
                      type="primary"
                      size="mini"
                      @click="editCredit(userDetail.uid, 2)"
                    >
                      确定
                    </el-button>
                  </div>
                  <el-button
                    slot="reference"
                    style="margin-left: 5px;"
                    class="edit"
                    size="mini"
                    circle
                    icon="el-icon-edit"
                    @click="editCredit_mobile"
                  ></el-button>
                </el-popover>
              </template>
            </div>
            <div class="user_msg_item">会员卡号：{{ userDetail.card_num }}</div>
            <div class="user_msg_item" v-if="userDetail.user_info.plate">
              车牌号：{{ userDetail.user_info.plate }}
              <template>
                <el-popover
                  placement="top"
                  width="160"
                  trigger="manual"
                  v-model="plate_visible"
                >
                  <el-input
                    size="mini"
                    style="margin-bottom: 10px;"
                    v-model="plate"
                    placeholder="请输入内容"
                  ></el-input>
                  <div style="text-align: right; margin: 0;">
                    <el-button
                      size="mini"
                      type="text"
                      @click="plate_visible = false"
                    >
                      取消
                    </el-button>
                    <el-button
                      type="primary"
                      size="mini"
                      @click="editCredit(userDetail.uid, 1)"
                    >
                      确定
                    </el-button>
                  </div>
                  <el-button
                    slot="reference"
                    style="margin-left: 5px;"
                    class="edit"
                    size="mini"
                    circle
                    icon="el-icon-edit"
                    @click="editplate"
                  ></el-button>
                </el-popover>
              </template>
            </div>
            <div class="user_msg_item" v-else>
              车牌号：未知
              <template>
                <el-popover
                  placement="top"
                  width="160"
                  trigger="manual"
                  v-model="plate_visible"
                >
                  <el-input
                    size="mini"
                    style="margin-bottom: 10px;"
                    v-model="plate"
                    placeholder="请输入内容"
                  ></el-input>
                  <div style="text-align: right; margin: 0;">
                    <el-button
                      size="mini"
                      type="text"
                      @click="plate_visible = false"
                    >
                      取消
                    </el-button>
                    <el-button
                      type="primary"
                      size="mini"
                      @click="editCredit(userDetail.uid, 1)"
                    >
                      确定
                    </el-button>
                  </div>
                  <el-button
                    slot="reference"
                    style="margin-left: 5px;"
                    class="edit"
                    size="mini"
                    circle
                    icon="el-icon-edit"
                    @click="editplate"
                  ></el-button>
                </el-popover>
              </template>
            </div>
            <!-- <div class="user_msg_item">实体卡号：{{ userDetail.card_num }}</div> -->
          </div>
          <div class="user_button">
            <el-button
              size="small"
              v-for="(item, index) in buttonList"
              :key="index"
              @click="userButton(index)"
            >
              {{ item.name }}
            </el-button>
            <div class="el-button el-button--small" @click="clickCoupon">
              优惠券
              <span style="color: red;">({{ userDetail.coupon_num }})</span>
              查看
            </div>
            <div class="el-button el-button--small" @click="vipDesc">
              会员备注
            </div>
            <div class="el-button el-button--small" @click="showPayPassDg">
              支付密码
            </div>
          </div>
        </div>
      </div>
      <!-- 会员标签 -->
      <div class="user_tag part_box" @click="isShowTabs">
        标签：{{ userTags }}
      </div>
      <!-- 会员信息菜单 -->
      <div class="part_box">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="账户信息" name="1">
            <div class="account_base_msg">
              <div class="account_item">
                会员等级：{{ userDetail.card ? userDetail.card.name : "" }}
              </div>
              <div class="account_item">
                账户积分：{{ userDetail.user_info.wallet.point }}
              </div>
              <div class="account_item">
                成为会员时间：{{ userDetail.create_time }}
              </div>
              <div class="account_item">备注：{{ userDetail.remark }}</div>
              <div class="account_item">
                账户总余额：{{ userDetail.user_info.wallet.balance }}
              </div>
              <div class="account_item">
                会员卡余额：{{ userDetail.user_info.wallet.wallet_balance }}
              </div>
              <div
                class="account_item"
                v-for="item in userDetail.card_info"
                :key="item.id"
              >
                {{ item.name + "余额" }}：{{ item.balance }}
              </div>
              <div class="account_item">
                累计消费：{{ userDetail.total_custom }}
              </div>
              <div class="account_item">
                累计积分：{{ userDetail.total_point }}
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="油品订单" name="2">
            <order-list :uid="order_uid"></order-list>
          </el-tab-pane>
          <el-tab-pane label="充值订单" name="3">
            <voucher-list :uid="String(userDetail.uid)"></voucher-list>
          </el-tab-pane>
          <el-tab-pane label="积分变动记录" name="4" v-if="point_logs == 1">
            <point-change :uid="String(userDetail.uid)"></point-change>
          </el-tab-pane>
          <el-tab-pane label="余额变动记录" name="5" v-if="isShowYE == 1">
            <balance-change :uid="String(userDetail.uid)"></balance-change>
          </el-tab-pane>
          <el-tab-pane label="优惠券领取记录" name="6">
            <couponListCompont
              :uid="String(userDetail.uid)"
            ></couponListCompont>
          </el-tab-pane>
          <el-tab-pane label="优惠券核销记录" name="7">
            <couponListHx :uid="String(userDetail.uid)"></couponListHx>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 弹窗 -->
    <!-- 修改账户余额/积分信息 -->
    <UserAccount
      :showAccount="showAccount"
      :accountData="accountData"
      @close="showAccount = false"
      @refresh="getData"
      :tabs="accountTabs"
    ></UserAccount>
    <!-- 发送优惠券弹窗 -->
    <el-dialog
      :visible.sync="showSendCoupon"
      title="发送优惠券"
      @close="closeSend"
      width="600px"
    >
      <div>
        <el-form label-width="90px" size="">
          <el-form-item label="发送给" style="margin-bottom: 0;">
            {{ userDetail.user_info.real_name }}
          </el-form-item>
          <el-form-item label="优惠券">
            <el-tag
              v-for="(tag, idx) in sList"
              :key="tag.id"
              closable
              @close="delTagItem(idx)"
              style="margin-bottom: 5px; margin-right: 5px;"
            >
              {{ tag.name }}
            </el-tag>
            <el-button size="small" @click="showSelecter = true">
              选择
            </el-button>
          </el-form-item>
          <verificationCodeVue v-model="code_num" v-if="sms_stats.open_sms_coupon == 1"></verificationCodeVue>
          <!-- <el-form-item
            label="验证码"
            style="width: 386px;"
            v-if="sms_stats.open_sms_coupon == 1"
          >
            <el-input class="input_box" v-model="code_num">
              <template slot="append">
                <el-link
                  :disabled="btn_status"
                  @click="getCode(0)"
                  type="primary"
                >
                  {{ code_text }}
                </el-link>
              </template>
            </el-input>
          </el-form-item> -->
        </el-form>
        <div style="text-align: center;">
          <el-button type="primary" @click="clickSend()">发送</el-button>
          <el-button @click="closeSend()">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 选择优惠券弹窗 -->
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false">
      <selectCommodity
        @close="showSelecter = false"
        @getCommod="getCommod"
        :sList="sList"
        :jude="2"
      ></selectCommodity>
    </el-dialog>
    <!-- 会员备注 -->
    <el-dialog
      :visible.sync="showChangevipRemark"
      title="会员备注"
      width="600px"
    >
      <el-form label-width="90px" size="">
        <el-form-item label="备注">
          <el-input type="textarea" autosize v-model="vipRemark"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center;">
        <el-button type="primary" @click="setVipRemarks()">确定</el-button>
        <el-button @click="showChangevipRemark = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showPayPass"
      title="是否免密"
      width="600px"
    >
      <el-form label-width="90px" size="">
        <el-form-item label="是否免密">
            <el-radio v-model="payPayssForm.is_balance_confidential_payment" :label="0">否</el-radio>
            <el-radio v-model="payPayssForm.is_balance_confidential_payment" :label="1">是</el-radio>
        </el-form-item>
        <el-form-item label="支付密码" v-if="payPayssForm.is_balance_confidential_payment==0">
          <el-input show-password v-model="payPayssForm.pay_password"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center;">
        <el-button type="primary" @click="setPayPassFunc()">确定</el-button>
        <el-button @click="showPayPass = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 修改用户等级弹窗 -->
    <el-dialog
      :visible.sync="showChangeLevel"
      @close="closeChange"
      title="会员调级"
      width="600px"
    >
      <div>
        <el-form label-width="90px" size="">
          <el-form-item label="调级">
            <el-select
              v-model="change_level_id"
              size="small"
              placeholder="请选择"
            >
              <el-option-group
                v-for="(group, i) in groupList"
                :key="i"
                :label="group.name"
              >
                <el-option
                  v-for="item in group.lists"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <verificationCodeVue v-model="code_num" v-if="sms_stats.open_update_level == 1"></verificationCodeVue>
          <!-- <el-form-item
            label="验证码"
            style="width: 386px;"
            v-if="sms_stats.open_update_level == 1"
          >
            <el-input class="input_box" v-model="code_num">
              <template slot="append">
                <el-link
                  :disabled="btn_status"
                  @click="getCode(0)"
                  type="primary"
                >
                  {{ code_text }}
                </el-link>
              </template>
            </el-input>
          </el-form-item> -->
        </el-form>
        <div style="text-align: center;">
          <el-button type="primary" @click="clickChangeLevel()">确定</el-button>
          <el-button @click="closeChange()">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 添加会员标签 -->
    <el-dialog
      :visible.sync="showUserTag"
      title="添加会员标签"
      @close="closeTag(0)"
      width="400px"
    >
      <user-tag :uid="userDetail.uid" @closeTag="closeTag"></user-tag>
    </el-dialog>
    <!-- 添加会员标签 -->
    <el-dialog :visible.sync="showIcTag" title="绑定实体卡" width="460px">
      <el-form ref="form" :model="icForm" label-width="100px">
        <el-form-item label="识别卡号">
          <div style="display: flex;">
            <el-input
              type="textarea"
              autosize
              v-model="icForm.card_num"
              @input="changeIc"
            ></el-input>
            <el-button size="small" @click="reset">重置</el-button>
          </div>
        </el-form-item>
        <div v-if="is_SetPassworld">
          <el-form-item label="用户手机号">
            <el-input v-model="icForm.mobile" disabled></el-input>
          </el-form-item>
          <verificationCodeVue :form="{
                    mobile:icForm.mobile
                  }" :typeCode="1"  v-model="icForm.code" ></verificationCodeVue>
          <!-- <el-form-item label="验证码">
            <el-input class="input_box" v-model="icForm.code">
              <template slot="append">
                <el-link
                  :disabled="btn_status"
                  @click="getCode(1)"
                  type="primary"
                >
                  {{ code_text }}
                </el-link>
              </template>
            </el-input>
          </el-form-item> -->
          <el-form-item label="设置密码">
            <el-input show-password v-model="icForm.pay_pass"></el-input>
          </el-form-item>
          <el-form-item label="确认密码">
            <el-input show-password v-model="icForm.re_pay_pass"></el-input>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="密码">
            此用户已经检测到在微信设置了密码
            <!-- <el-button size="small">重置</el-button> -->
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showIcTag = false">取 消</el-button>
        <el-button type="primary" @click="addIC">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="resetShow"
      title="重新绑定实体卡"
      width="460px"
      :show-close="false"
    >
      <el-form ref="form" :model="icForm" label-width="100px">
        <el-form-item label="识别卡号">
          <div style="display: flex;">
            <el-input
              type="textarea"
              autosize
              v-model="icForm.card_num"
              @input="changeIc"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="用户手机号">
          <el-input v-model="icForm.mobile" disabled></el-input>
        </el-form-item>
        <verificationCodeVue :form="{
                    mobile:icForm.mobile
                  }" :typeCode="1"  v-model="icForm.code" ></verificationCodeVue>
        <!-- <el-form-item label="验证码">
          <el-input class="input_box" v-model="icForm.code">
            <template slot="append">
              <el-link
                :disabled="btn_status"
                @click="getCode(1)"
                type="primary"
              >
                {{ code_text }}
              </el-link>
            </template>
          </el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetShow = false">取 消</el-button>
        <el-button type="primary" @click="addIC(1)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 优惠券 -->
    <el-dialog
      :visible.sync="couponListShow"
      title="优惠券"
      width="70%"
      :show-close="false"
    >
      <div class="coupon">
        <!-- <el-tabs v-model="activeCoupon" type="card" @tab-click="handleCoupon">
          <el-tab-pane
            v-for="(item, index) in couponType"
            :key="index"
            :label="item.name"
            :name="item.type"
          ></el-tab-pane>
        </el-tabs> -->
        <el-radio-group
          v-model="activeCoupon"
          style="margin-bottom: 30px;"
          @change="handleCoupon"
        >
          <el-radio-button
            v-for="(item, index) in couponType"
            :key="index"
            :label="item.type"
          >
            {{ item.name }}
          </el-radio-button>
        </el-radio-group>
        <div class="option">
          <div>
            共
            <span style="color: #409eff;">
              {{ total }}
            </span>
            张
          </div>
          <el-button type="text" @click="showSendCoupon = true">发券</el-button>
        </div>
        <div class="table">
          <el-table
            :data="couponData"
            style="width: 100%;"
            height="300px"
            v-loading="loadingPopup"
          >
            <el-table-column prop="title" label="优惠券名称"></el-table-column>
            <el-table-column prop="get_time" label="领取时间"></el-table-column>
            <el-table-column prop="getType" label="领取途径"></el-table-column>
            <el-table-column label="有效期">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.start_time }} 至 {{ scope.row.end_time }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" v-if="activeCoupon == 0">
              <template slot-scope="scope">
                <el-button type="text" @click="cancellation(scope.row.id)">
                  作废
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page">
          <el-pagination
            layout="prev, pager, next, total, jumper"
            :current-page="page"
            :total="total"
            :page-size="10"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="couponListShow = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  changeUserLevel,
  levelGroupSelect,
  sendCoupon,
  vipList,
  vipUserDetail,
  getVipRemark,
  setVipRemark,
  getPayPassConfig,
  setPayPassConfig,
} from "@/api/vip";
import {
  bindingIc,
  detailIc,
  iCSendSms,
  judgePayPass,
  setPayPass,
} from "@/api/ic";
import { couponCancle_expser, couponVerifiy } from "@/api/coupon";
import { userEdit } from "@/api/user";
import { listCommonTag } from "@/api/market";
import { mapGetters } from "vuex";
import { SendAdminCode, privacy } from "@/api/set";
import OrderList from "@/views/apply/newVip/order/oilsList";
import VoucherList from "@/views/apply/newVip/order/voucherList";
import UserAccount from "@/views/apply/vip/vipUserAccount";
import selectCommodity from "@/components/commodity/selectCommodity.vue";
import PointChange from "./pointChangeList";
import couponListCompont from "./couponListCompont";
import couponListHx from "./couponListHx.vue";
import BalanceChange from "./balanceChangeList";
import UserTag from "@/components/vip/userTags";
import verificationCodeVue from "@Components/verification/verificationCode"
// import Template from '../set/smsConfig/template.vue';
export default {
  data() {
    return {
      showChangevipRemark: false,
      vipRemark: "",
      isShowYE: 1,
      point_logs: 1,
      credit: "",
      plate: "",
      verification_code: "",
      // code_text: "获取验证码",
      plate_visible: false,
      visible_mobile: false,
      // mobile:'',
      visible: false,
      username: "",
      loadingPopup: false,
      couponType: [
        {
          name: "有效券",
          type: "0",
        },
        {
          name: "失效券",
          type: "1",
        },
      ],
      page: 1, //当前页码
      total: 0,

      couponData: [],
      activeCoupon: "0",
      couponListShow: false,
      squareUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      userDetail: {
        uid: "",
        card: {},
        user_info: {
          wallet: {},
        },
      },
      sms_stats: {},
      code_num: "",
      code_text: "获取验证码",
      btn_status: false,
      timer: null,
      now_code: "",
      user_id: 0,
      buttonList: [
        { name: "会员充值" },
        { name: "积分调整" },
        { name: "送优惠券" },
        { name: "会员调级" },
        { name: "会员标签" },
        { name: "绑定实体卡" },
      ],
      userTags: "暂无标签", //会员标签
      activeName: "1", // 用户信息tab页
      showAccount: false, //显示修改账户弹窗
      accountData: {}, //用户账户信息
      accountTabs: "point", //充值类型 point:积分 balance:余额
      showChangeLevel: false, //会员调级窗口
      change_level_id: "", //调整等级id
      showSendCoupon: false, //显示发送优惠券弹窗
      showSelecter: false, // 选择优惠券弹窗
      sList: [], //已选择优惠券列表
      level_options: [], //会员卡等级列表
      commonList: [], // 手动标签列表
      showUserTag: false, // 会员标签弹窗
      showIcTag: false, // 实体卡弹窗
      order_uid: "",
      icForm: {
        card_num: "",
        mobile: "",
        code: "",
        pay_pass: "",
        re_pay_pass: "",
        type: "0",
      },
      is_SetPassworld: false,
      resetShow: false,
      pageLoading: false, // 页面记载loading
      groupList: [],
      showNum: 0,
      payPayssForm:{
        is_balance_confidential_payment:0,
        pay_password:""
      },
      showPayPass:false
    };
  },
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  components: {
    OrderList,
    VoucherList,
    UserAccount,
    selectCommodity,
    PointChange,
    BalanceChange,
    UserTag,
    couponListCompont,
    couponListHx,
    verificationCodeVue
    // Template,
  },
  async mounted() {
    this.init();
    this.getData();
    this.sms_stats = await this.get_prosms_ob()
    this.getShowTabs();
  },
  methods: {
    isShowTabs() {
      this.showNum++;
      if (this.showNum == 6) {
        this.visible_yue = true;
      }
    },
    async getShowTabs() {
      const res = await privacy({ app_id: this.app_id });
      if (res.data.balance_logs == 0 || res.data.balance_logs == 1) {
        this.isShowYE = res.data.balance_logs;
      }
      if (res.data.point_logs == 0 || res.data.point_logs == 1) {
        this.point_logs = res.data.point_logs;
      }
    },
    vipDesc() {
      this.showChangevipRemark = true;
      this.getVipRemarks();
    },
    showPayPassDg() {
      this.payPayssForm = {
        is_balance_confidential_payment:0,
        pay_password:""
      }
      this.getPayPassConfigFunc()
      this.showPayPass = !this.showPayPass;
    },
    async setPayPassFunc(){
      const res = await setPayPassConfig({
        app_id:this.app_id,
        uid:this.userDetail.uid,
        is_balance_confidential_payment:this.payPayssForm.is_balance_confidential_payment,
        pay_password:this.payPayssForm.pay_password
      });
      if(res.code==200){
        this.$message.success(res.msg);
        this.showPayPass = false;
      }else{
        this.$message.error(res.msg);
      }
    },
    getPayPassConfigFunc(){
      getPayPassConfig({
        app_id:this.app_id,
        uid:this.userDetail.uid,
      }).then(res=>{
        if(res.code==200){
          this.payPayssForm.is_balance_confidential_payment = res.data.is_balance_confidential_payment;
        }else{
          this.$message.error(res.msg);
        }
      })
    },
    async getVipRemarks() {
      const res = await getVipRemark({
        app_id: this.app_id,
        uid: this.userDetail.uid,
      });
      if (res.code === 200) {
        this.vipRemark = res.data.remark;
      }
    },
    async setVipRemarks() {
      const res = await setVipRemark({
        app_id: this.app_id,
        uid: this.userDetail.uid,
        remark: this.vipRemark,
      });
      if (res.code === 200) {
        this.showChangevipRemark = false;
        this.$message(res.msg);
      }
    },
    //编辑
    editCredit(id, key) {
      let data = {
        app_id: this.app_id,
        token: this.token,
        id: id,

        // plate:this.plate
      };
      switch (key) {
        case 0:
          console.log("789", data);
          data.real_name = this.username;
          userEdit(data).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.username = "";

              // this.credit = '',
              this.$message.success(res.msg);
              this.getData();
              this.visible = false;
            }
          });
          break;
        case 1:
          data.plate = this.plate;
          userEdit(data).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.plate = "";
              // this.credit = '',
              this.$message.success(res.msg);
              this.getData();
              this.plate_visible = false;
            }
          });
          break;
        case 2:
          var reg = /^(?:(?:\+|00)86)?1\d{10}$/;
          var flag = reg.test(this.icForm.mobile);
          if (flag) {
            data.mobile = this.icForm.mobile;
            data.verification_code = this.verification_code;
            if (data.verification_code !== "") {
              userEdit(data).then((res) => {
                console.log(res);
                if (res.code == 200) {
                  this.icForm.mobile = "";
                  (this.verification_code = ""), this.$message.success(res.msg);
                  this.getData();
                  this.visible_mobile = false;
                } else {
                  this.$message.error(res.msg);
                }
              });
            } else {
              this.$message.error("验证码不能为空");
            }
          } else {
            this.$message.error("手机号格式不正确");
          }

          break;
      }
    },
    editCredit_hym(id) {
      console.log("2324");
      this.visible = true;
      // this.credit = id;
      this.username = this.userDetail.user_info.real_name;
    },
    editCredit_mobile() {
      this.visible_mobile = true;
      this.mobile = this.userDetail.user_info.mobile;
    },
    editplate() {
      console.log("2324");
      this.plate_visible = true;
      if (this.userDetail.user_info.plate) {
        this.plate = this.userDetail.user_info.plate;
      }
      // this.credit = id;
      // this.username = this.userDetail.user_info.real_name;
    },
    // 作废优惠券
    handleCoupon() {
      console.log("作废优惠券tab", this.activeCoupon);
      this.page = 1;
      this.getCouponList();
    },
    cancellation(id) {
      let data = {
        token: this.token,
        app_id: this.app_id,
        store_id: 0, //
        coupon_ids: id,
        type: 0,
      };
      this.$confirm("作废是不可逆的，请谨慎作废?！！！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          couponCancle_expser(data).then((res) => {
            console.log("shanchu ", res);
            if (res.code == 200) {
              this.$message.success(res.msg);
            } else {
              this.$message("作废失败");
            }
          });
          this.getCouponList();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消作废",
          });
        });
    },
    clickCoupon() {
      this.couponListShow = true;
      this.getCouponList();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getCouponList();
    },
    getCouponList() {
      this.loadingPopup = true;
      let data = {
        token: this.token,
        app_id: this.app_id,
        uid: this.userDetail.uid,
        is_used: this.activeCoupon,
        is_exp: this.activeCoupon,
        page: this.page,
      };
      couponVerifiy(data).then((res) => {
        console.log("优惠券数据", res);
        if (res.code == 200) {
          this.total = res.data.total_num;
          this.couponData = res.data.result;
          this.couponData.forEach((item) => {
            item.getType =
              item.get_type == 0
                ? "平台发放"
                : item.get_type == 1
                ? "用户领取"
                : "赠送";
          });
        }
        this.loadingPopup = false;
      });
    },
    // 重置ic卡
    reset() {
      this.icForm.type = "1";
      this.showIcTag = false;
      this.resetShow = true;
      this.icForm.mobile = this.userDetail.user_info.mobile;
    },
    changeIc() {
      console.log("ka", this.icForm.card_num.length);
      if (this.icForm.card_num.length == 10) {
        console.log("ka");
        let data = {
          token: this.token,
          app_id: this.app_id,
          uid: this.userDetail.uid,
        };
        judgePayPass(data).then((res) => {
          if (res.code == 200) {
            this.is_SetPassworld = false;
          } else {
            this.is_SetPassworld = true;
          }
          console.log("数据", res);
        });
      }
    },
    addIC(type = 0) {
      console.log("type", type);
      if (type == 1) {
        bindingIc({
          app_id: this.app_id,
          token: this.token,
          card_num: this.icForm.card_num.replace(/[\r\n]/g, ""),
          uid: this.userDetail.uid,
          type: 1,
          mobile: this.icForm.mobile,
          code: this.icForm.code,
        }).then((secondData) => {
          if (secondData.code == 200) {
            this.icForm = {
              card_num: "",
              mobile: "",
              code: "",
              pay_pass: "",
              re_pay_pass: "",
            };
            this.$message.success("绑定成功！！");
            this.showIcTag = false;
            this.resetShow = false;
          } else {
            this.$message.warning(secondData.msg);
          }
        });
      } else {
        // 1,如果沒設置密碼先设置密码
        if (this.is_SetPassworld) {
          let data = {
            app_id: this.app_id,
            token: this.token,
            mobile: this.icForm.mobile,
            code: this.icForm.code,
            pay_pass: this.icForm.pay_pass,
            re_pay_pass: this.icForm.re_pay_pass,
          };
          setPayPass(data).then((res) => {
            console.log("122", res);
            if (res.code == 200) {
              bindingIc({
                app_id: this.app_id,
                token: this.token,
                card_num: this.icForm.card_num.replace(/[\r\n]/g, ""),
                uid: this.userDetail.uid,
              }).then((secondData) => {
                if (secondData.code == 200) {
                  this.icForm = {
                    card_num: "",
                    mobile: "",
                    code: "",
                    pay_pass: "",
                    re_pay_pass: "",
                  };
                  this.$message.success("绑定成功！！");
                  this.showIcTag = false;
                } else {
                  this.$message.warning(secondData.msg);
                }
              });
            }
          });
        } else {
          bindingIc({
            app_id: this.app_id,
            token: this.token,
            card_num: this.icForm.card_num.replace(/[\r\n]/g, ""),
            uid: this.userDetail.uid,
          }).then((secondData) => {
            if (secondData.code == 200) {
              this.icForm = {
                card_num: "",
                mobile: "",
                code: "",
                pay_pass: "",
                re_pay_pass: "",
              };
              this.$message.success("绑定成功！！");
              this.showIcTag = false;
            } else {
              this.$message.warning(secondData.msg);
            }
          });
        }
      }
    },
    // 设置验证码
    set_code(val) {
      this.now_code = val;
    },
    // 初始化
    init() {
      var data = {
        token: this.token,
        app_id: this.app_id,
      };
      vipList(data).then((res) => {
        if (res.code == 200) {
          res.data.forEach((item) => {
            this.level_options.push({ id: item.id, name: item.name });
          });
        } else {
        }
      });
      levelGroupSelect(data).then((res) => {
        if (res.code == 200) {
          this.groupList = res.data;
        }
      });
      listCommonTag(data).then((res) => {
        if (res.code == 200) {
          this.commonList = res.data;
        } else {
          this.$message.waring(res.msg);
        }
        console.log("手动标签列表", res);
      });
    },
    // 获取数据
    getData() {
      this.pageLoading = true;
      this.user_id = this.$route.query.id;
      var data = {
        token: this.token,
        app_id: this.app_id,
        uid: this.user_id,
      };

      vipUserDetail(data).then((res) => {
        this.pageLoading = false;
        if (res.code == 200) {
          console.log("usermsg", res.data);
          this.userDetail = res.data;
          // this.credit = res.data
          if (this.userDetail.user_info.headimgurl) {
            this.squareUrl = this.userDetail.user_info.headimgurl;
          }
        } else {
          this.$message(res.msg);
        }
      });
    },
    // 顶部按钮
    userButton(i) {
      if (i == 0) {
        //会员充值
        this.editAccount(1);
      } else if (i == 1) {
        //积分调整
        this.editAccount(2);
      } else if (i == 2) {
        //送优惠券
        this.showSendCoupon = true;
      } else if (i == 3) {
        //会员调级
        this.showChangeLevel = true;
      } else if (i == 4) {
        //会员标签
        this.showUserTag = true;
      } else if (i == 5) {
        //会员标签
        this.showIcTag = true;
        this.icForm.mobile = this.userDetail.user_info.mobile;
        detailIc({
          app_id: this.app_id,
          token: this.token,
          uid: this.userDetail.uid,
        }).then((res) => {
          if (res.code == 200) {
            this.icForm.card_num = res.data.card_num;
          }
        });
      }
    },
    // 修改账户积分/余额
    editAccount(type) {
      this.accountData = {
        uid: this.userDetail.uid,
        balance: this.userDetail.user_info.wallet.balance,
        point: this.userDetail.user_info.wallet.point,
        card_id: this.userDetail.user_info.card.id,
        alliance: this.userDetail.alliance,
      };
      this.accountTabs = type == 1 ? "balance" : "point";
      this.showAccount = true;
    },
    getCode(type) {
      console.log("type111111", type);
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        if (type == 0) {
          this.SendMyCode();
        } else if (type == 2) {
          this.SendUserCode(this.icForm.mobile);
        } else {
          this.SendUserCode(this.mobile);
        }
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
            this.code_text = this.count + "s";
            this.btn_status = true;
          } else {
            this.btn_status = false;
            this.timer = null;
            this.code_text = "获取验证码";
          }
        }, 1000);
      }
    },
    // 管理员发送验证码
    async SendMyCode() {
      try {
        var data = { app_id: this.app_id };
        const res = await SendAdminCode(data);
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 向用户发送验证码
    async SendUserCode() {
      try {
        var data = {
          app_id: this.app_id,
          token: this.token,
          mobile: this.icForm.mobile,
        };
        const res = await iCSendSms(data);
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    //选择优惠券
    getCommod(data) {
      console.log(data);
      this.sList = data;
      this.showSelecter = false;
    },
    //删除已选择优惠券
    delTagItem(i) {
      this.sList.splice(i, 1);
    },
    //发送
    clickSend() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        verification_code: this.code_num,
      };
      data.uid = this.userDetail.uid;
      data.id = this.sList.map((i) => i.id).join(",");
      console.log(data);
      sendCoupon(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "发送成功",
          });
          this.closeSend();
          // youhuiquan
          this.page = 1;
          this.getCouponList();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    //关闭发送优惠券窗口
    closeSend() {
      this.sList = [];
      this.num = "";
      clearTimeout(this.timer);
      this.showSendCoupon = false;
    },
    // 调级保存
    clickChangeLevel() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        user_level_id: this.change_level_id,
        verification_code: this.code_num,
      };
      data.uids = this.userDetail.uid;
      console.log(data);
      // return false;
      changeUserLevel(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.closeChange();
          this.getData();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    // 关闭调级弹窗
    closeChange() {
      this.change_level_id = "";
      this.showChangeLevel = false;
    },
    // 切换tab页
    handleClick(val) {
      console.log(val);
      if (val.name == "2") {
        this.order_uid = String(this.userDetail.uid);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    closeTag(i) {
      this.showUserTag = false;
      if (i == 1) {
        this.getData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// 验证码
.verification-code {
  display: flex;
  justify-content: space-between;
}
.page_background {
  background: #fff;
  height: 100%;
  padding: 10px;
  .title_line {
    height: 34px;
  }
}
.new_vip {
  padding: 10px;
  height: calc(100% - 32px);
  background: #f1f2f6;
  overflow: auto;
  .part_box {
    background: #fff;
    margin-bottom: 10px;
    border-radius: 6px;
    padding: 10px;
  }
  .head_msg {
    display: flex;
    .head_img {
      border-right: 1px solid #eee;
      padding-right: 10px;
      margin-right: 15px;
    }
    .user_msg {
      flex: 1;
      .user_msg_line {
        display: flex;
        flex-wrap: wrap;
        .user_msg_item {
          padding-top: 10px;
          line-height: 25px;
          margin-right: 15px;
          width: 240px;
        }
      }
      .user_button {
        margin-top: 15px;
      }
    }
  }
  .user_tag {
    height: 60px;
    line-height: 40px;
    padding-left: 20px;
  }
  .account_base_msg {
    line-height: 30px;
  }
}
// 优惠券弹窗
.coupon {
  width: 100%;
  .option {
    display: flex;
    justify-content: space-between;
  }
  .page {
    margin-top: 20px;
    text-align: center;
  }
}
</style>
